const Logo = () => {
  return (
    <div className="logo inverseNav">
      <svg
        width="40"
        height="40"
        viewBox="0 0 50 50"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <circle cx="25" cy="25" r="25" fill="#B7AB98" />
        <circle cx="25" cy="25" r="11.5" stroke="black" stroke-width="2" />
      </svg>
      <div className="logo__name e-mf">
        <h5>avdhesh</h5>
        <h6>yadav</h6>
      </div>
    </div>
  );
};

export default Logo;
